import styled from 'styled-components';
import Inner from '../components/Inner';

const Wrapper = styled.div`
  background-color: #000;
`;

const StyledSection = styled.div`
  color: #eee;
  height: 100vh;
  overflow: hidden;
`;

const StyledInner = styled(Inner)`
  display: flex;
  align-items: center;
  justify-content: start;
  height: 100%;
  position: relative;
`;

const CopyWrite = styled.div`
  position: relative;
  top: -75px; // Header의 높이
`;

const Line = styled.div`
  font-size: 5rem;
  color: #eee;

  & + & {
    margin-top: 2rem;
  }

  @media screen and (max-width: 768px) {
    font-size: 3rem;
  }

  @media screen and (min-width: 769px) and (max-width: 1023px) {
    font-size: 4rem;
  }
`;

function Home() {
  return (
    <>
      <Wrapper>
        <StyledSection>
          <StyledInner>
            <CopyWrite>
              <Line>Archive</Line>
              <Line>: 기록하다</Line>
            </CopyWrite>
          </StyledInner>
        </StyledSection>
        <StyledSection>
          <StyledInner>
            <div>
              <Line>Connect</Line>
              <Line>: 연결하다</Line>
            </div>
          </StyledInner>
        </StyledSection>
      </Wrapper>
    </>
  );
}

export default Home;
